const RegisterCollaboratorValidator = (t) => {

  let regexs = {
    firstNameRegex: new RegExp(/^[A-Za-zñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0 ]* ?()[A-Za-zñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0 ]* ?()[A-Za-zñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0.-\s?]*$/),
    firstLastNameRegex: new RegExp(/^[A-Za-zñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0 ]* ?()[A-Za-zñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0 ]* ?()[A-Za-zñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0 ]*$/),
    secondLastNameRegex: new RegExp(/^[A-Za-zñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0 .-]* ?()[A-Za-zñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0 .-]* ?()[A-Za-zñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0 .-]*$/),
    streetRegex: new RegExp(/^[A-Za-z0-9 áéíóúÁÉÍÓÚÑñ.,;:#-]+$/),
    suburbRegex: new RegExp(/^[A-Za-z0-9 áéíóúÁÉÍÓÚÑñ.,;:#-]+$/),
    townRegex: new RegExp(/^[A-Za-z0-9 ñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ,.-]+$/),
    stateRegex: new RegExp(/^[A-Za-z0-9 ñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ,.-]+$/),
    countryRegex: new RegExp(/^[A-Za-z0-9 ñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ,.-]+$/),
    zipCodeRegex: new RegExp(/(^\d{5}$)|(^\d{5}-\d{4}$)/),
    phoneNumberRegex: new RegExp(/^[0-9-]+$/),
    cellPhoneNumberRegex: new RegExp(/^[0-9-]+$/),
    internalNumberRegex: new RegExp(/^[A-Za-z0-9 áéíóúÁÉÍÓÚÑñ.,;:#-]+$/),
    externalNumberRegex: new RegExp(/^[A-Za-z0-9 áéíóúÁÉÍÓÚÑñ.,;:#-]+$/),
    rfcRegex: new RegExp(/^([A-ZÑ&]{4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/),
  }

  let validators = {
    firstNameValidator: (value) => {
      if (value && value.length > 0) {
        return (regexs.firstNameRegex.test(value) ? '' : t('register.collaborator.firstNameValidator'))
      }
    },
    firstLastNameValidator: (value) => {
      if (value && value.length > 0) {
        return (regexs.firstLastNameRegex.test(value) ? '' : t('register.collaborator.firstLastNameValidator'))
      }
    },
    secondLastNameValidator: (value) => {
      if (value && value.length > 0) {
        return (regexs.secondLastNameRegex.test(value) ? '' : t('register.collaborator.secondLastNameValidator'))
      }
    },
    phoneNumberValidator: (value) => {
      if (value && value.length > 0) {
        return (regexs.phoneNumberRegex.test(value) ? '' : t('register.collaborator.phoneNumberValidato'))
      }
    },
    cellPhoneValidator: (value) => {
      if (value && value.length > 0) {
        return (regexs.cellPhoneNumberRegex.test(value) ? '' : t('register.collaborator.cellPhoneValidato'))
      }
    },
    streetValidator: (value) => {
      if (value && value.length > 0) {
        return (regexs.streetRegex.test(value) ? '' : t('register.collaborator.streetValidato'))
      }
    },
    suburbValidator: (value) => {
      if (value && value.length > 0) {
        return (regexs.suburbRegex.test(value) ? '' : t('register.collaborator.suburbValidato'))
      }
    },
    townshipValidator: (value) => {
      if (value && value.length > 0) {
        return (regexs.townRegex.test(value) ? '' : t('register.collaborator.townshipValidato'))
      }
    },
    stateValidator: (value) => {
      if (value && value.length > 0) {
        return (regexs.stateRegex.test(value) ? '' : t('register.collaborator.stateValidato'))
      }
    },
    countryValidator: (value) => {
      if (value && value.length > 0) {
        return (regexs.countryRegex.test(value) ? '' : t('register.collaborator.countryValidato'))
      }
    },
    zipCodeValidator: (value) => {
      if (value && value.length > 0) {
        return (regexs.zipCodeRegex.test(value) ? '' : t('register.collaborator.zipCodeValidato'))
      }
    },
    rfcValidator: (value) => {
      if (value && value.length > 0) {
        return (regexs.rfcRegex.test(value.toUpperCase()) ? '' : t('register.collaborator.rfcValidato'))
      }
    },
    internalNumberValidator: (value) => {
      if (value && value.length > 0) {
        return (regexs.internalNumberRegex.test(value) ? '' : t('register.collaborator.internalNumberValidato'))
      }
    },
    externalNumberValidator: (value) => {
      if (value && value.length > 0) {
        return (regexs.externalNumberRegex.test(value) ? '' : t('register.collaborator.externalNumberValidato'))
      }
    }
  }

  return validators
}

export { RegisterCollaboratorValidator as default }
